import { useMemo } from 'react';
import { MediaImage } from '@elfsight/widget-media';
import { truncateText, useIsMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

export const Image = () => {
  const { image, imageSizeMobile, imageSize, message } = useSettings();

  const isMobile = useIsMobile();

  const { width, height } = useMemo(() => {
    if (!image?.width || !image?.height) {
      return {
        height: 0,
        width: 0
      };
    }

    const ratio = image.width / image.height;
    const isHorizontal = ratio > 1;
    const maxSize = isMobile ? imageSizeMobile : imageSize;

    if (isHorizontal) {
      return { height: maxSize / ratio, width: maxSize };
    } else {
      return { height: maxSize, width: maxSize * ratio };
    }
  }, [image, imageSize, imageSizeMobile, isMobile]);

  if (!image?.url) return;

  return (
    <MediaImage
      style={{ borderRadius: '4px' }}
      containerWidth={`${width}px`}
      containerHeight={`${height}px`}
      mode="contain"
      src={image?.url}
      alt={truncateText(message)}
    />
  );
};
